import { h } from "preact";

import { classNames } from "../helpers.js";
import i18n from "../i18n.js";
import Button from "./Button.jsx";
import Icon from "./Icon.jsx";

export default function BackButton({ children, ...props }) {
  return (
    <Button
      text
      type="button"
      {...props}
      iconFront={<Icon class="rotate-180">arrow_forward</Icon>}
      class={classNames("waves-teal", props.class)}
    >
      {children || i18n.t("actions.back")}
    </Button>
  );
}
